import React from 'react';
import { Consumer } from 'contexts/BrowserHistory/BrowserHistoryContext';

export default Component => props => (
    <Consumer>
        {({ state, actions }) => (
            <Component
                {...props}
                {...actions}
                location={state?.location || {}}
            />
        )}
    </Consumer>
);
